export const DEFAULT_PAGE = 1;
export const MIN_PAGE = 1;
export const MIN_PAGE_SIZE = 1;
export const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];
export const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[0] as number;
export const MAX_PAGE_SIZE = PAGE_SIZE_OPTIONS[
  PAGE_SIZE_OPTIONS.length - 1
] as number;
